// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-box[data-v-b82f1a9a]{display:flex;align-items:center}.product-quantity[data-v-b82f1a9a],.product-title[data-v-b82f1a9a]{margin-bottom:10px}.product-list[data-v-b82f1a9a]{margin-bottom:30px}@media (max-width:1023px){.filter-aside .filter-info[data-v-b82f1a9a]{padding-bottom:30px;align-items:flex-end}}", ""]);
// Exports
module.exports = exports;
